module.exports = __webpack_public_path__ + "fj.svg?c886a16e5f09a59192253c3a614d6908";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/fj.svg
// module id = 804
// module chunks = 27